const classificationTypes = {
  appointment: 1,
  certification: 2,
};

const classificationTypesString = {
  [classificationTypes.appointment]: 'Cita',
  [classificationTypes.certification]: 'Certificación',
};

const getClassificationNameByType = (type) => {
  return classificationTypesString[type];
};

export {
  classificationTypes,
  classificationTypesString,
  getClassificationNameByType,
};
